<div class="global-configurations">
  <mat-expansion-panel
    [expanded]="isTrustedDomainsExpanded"
    (expandedChange)="isTrustedDomainsExpanded = $event"
    class="config-panel"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>Trusted Domains</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="panel-content">
      <div class="domain-input-row">
        <input type="text" class="domain-input" placeholder="example.com" />
        <app-button buttonText="Add Domain" (buttonClicked)="(null)"></app-button>
        <button class="upload-button">Upload</button>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel
    [expanded]="isEndpointFilteringExpanded"
    (expandedChange)="isEndpointFilteringExpanded = $event"
    class="config-panel"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>Endpoint Filtering</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="panel-content">
      <p class="placeholder-text">Endpoint filtering configuration will be implemented in Phase 2</p>
    </div>
  </mat-expansion-panel>
</div>
